import styled from "styled-components";

export const FieldContainer = styled.div`
  margin-top: 0px;
`;

export const Label = styled.div`
  font-size: 10px;
  font-style: normal;
  font-family: "PP Formula";
  font-weight: 400;
  line-height: 14px;
`;

export const ClickableLabel = styled.span`
  cursor: pointer;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: ${({ theme }) => theme.global.primaryColor};
`;

export const FooterLabel = styled.div`
  color: #6b778c;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  margin-left: 380px;
  line-height: normal;
`;

export const CosmosLabel = styled.div`
  font-weight: 400;
  font-size: 12px;
  margin-top: 8px;
  line-height: 16px;
  color: #7a869a;
  margin-bottom: 5px;
`;

export const LabelIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 12px;
`;

export const IconContainer = styled.div`
  display: grid;
  place-content: center;
  width: 24px;
  height: 24px;
  min-width: 24px;
  cursor: pointer;
`;

export const SmallIconContainer = styled.div`
  display: grid;
  place-content: center;
  width: 20px;
  height: 20px;
  min-width: 20px;
  cursor: pointer;
`;

export const Divider = styled.div`
  border-top: 1px solid ${(props) => props.theme.sidebar.borderColor};
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const AlreadyExistMessage = styled.div`
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #7a869a;
  margin-bottom: 5px;
  margin-top: 4px;
`;

export const BannerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - 120px);
`;

export const LightGrayDivider = styled.div`
  border-bottom: 1px solid #f4f5f7;
  margin-top: 20px;
  margin-bottom: 19px;
  width: 100%;
`;

export const HelperMessage = styled.div`
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #7a869a;
  margin-bottom: 5px;
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-flow: row;
  gap: 8px;
  justify-content: space-between;
`;

export const SizeContainer = styled.div`
  width: 72px;
  height: 40px;
  border-radius: 3px;
  background: #f4f5f7;
  ${(props) =>
    props.selected &&
    `
        background: #2F7AFF!important;
    `};
`;

export const SizeText = styled.div`
  top: 12px;
  position: relative;
  color: #42526e;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const SizeContainerWrapper = styled.div`
  display: flex;
  flex-flow: row;
  gap: 8px;
`;

export const OptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: ${({ alignItems = "center" }) => alignItems};
`;

export const OptionLabel = styled.span`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
`;

export const OptionContent = styled.div`
  width: 180px;
  flex-shrink: 0;
`;

export const SettingsOptionContainer = styled.div`
  padding-bottom: 20px;
  border-bottom: 1px solid ${({ theme }) => theme.border.black15};
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SettingsOptionHeading = styled.h1`
  margin: 0;
  font-size: 12px;
  font-family: "PP Formula";
  color: ${({ theme }) => theme.text.title};
  font-weight: 500;
  line-height: 18px;
`;

export const PoweredByCosmos = styled.h2`
  margin: 0;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  opacity: 0.5;
  color: ${({ theme }) => theme.text.text};
`;

export const SelectFieldContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
`;

export const GoogleCalendarInvalidUrl = styled.div`
  color: #bf2600;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px; /* 116.667% */
  padding-left: 2px;
`;

export const OptionWrapper = styled.div`
  display: grid;
  grid-template-columns: 24px auto;
  align-items: center;
  column-gap: 12px;
`;

export const OptionImage = styled.img`
  border-radius: 24px;
  width: 24px;
  height: 24px;
  object-fit: cover;
`;

export const OptionIcon = styled.div`
  width: 24px;
  height: 24px;
  min-width: 24px;
  display: grid;
  place-content: center;
`;

export const HeaderLabel = styled.span`
  color: ${({ theme }) => theme.text.text}
  font-size: 11px;
  font-family: "PP Formula";
  font-weight: 500;
  line-height: 16px;
  text-transform: uppercase;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 5px;
`;

export const SelectableUserWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 8px;
  column-gap: 16px;
`;

export const SpinnerContainer = styled.div`
  display: grid;
  place-content: center;
  margin-top: 25px;
`;

export const ItalicInfo = styled.span`
  color: #626f86;
  font-size: 12px;
  font-style: italic;
  font-weight: 300;
  line-height: 20px;
  white-space: nowrap;
`;

export const WideButton = styled.button`
  all: unset;
  display: grid;
  place-content: center;
  text-align: center;

  padding: 6px 12px;
  width: 100%;
  box-sizing: border-box;

  border-radius: 3px;
  background-color: ${({ theme }) => theme.orgchart.buttonColorHover};
  color: ${({ theme }) => theme.orgchart.buttonTextColor};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;

  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.orgchart.buttonColorActive};
  }
`;
